import { ReactNode, ReactElement, Fragment } from "react";

type TextProp = {
  value: string;
  args?: { [key: string]: ReactNode };
  regex?: RegExp;
};

export function Text({ args, ...otherProps }: TextProp): ReactElement {
  const text = otherProps.value;
  const regex = otherProps.regex || /{{(.+?)}}/g;
  let index = 0;
  const result = [];
  for (;;) {
    const match = regex.exec(text);
    if (match === null) {
      break;
    }
    const right = regex.lastIndex;
    const left = right - match[0].length;
    result.push(text.substring(index, left));
    if (args) {
      result.push(<Fragment key={`arg-${left}`}>{args[match[1]]}</Fragment>);
    } else {
      result.push(match[0]);
    }

    index = right;
  }
  result.push(text.substring(index));
  return <>{result}</>;
}
